import MdDivider from "./MdDivider"

const MdDividerPlugin = {
  install(app) {
    app.component(MdDivider.name, MdDivider)
  },
}

export default MdDividerPlugin
